import { pushNewsletterTrackingEvent } from '@utils/tracking-utils'
import { Country } from 'config'
import { SendGridMailingList, SendGridRequest } from 'pages/api/email-sign-up'
import removeQueryParam from './removeQueryParam'

const signupNewsletter = async (data: {
  email: string
  list: SendGridMailingList
  country: Country
  language: string
  getCountry: string
}) => {
  const urls = window.dataLayer.filter((x: any) => x.event == 'pageview')
  let lastUrl = urls.length > 1 ? urls[urls.length - 2].pagePath : ''
  let url = urls[urls.length - 1].pagePath

  lastUrl = removeQueryParam(lastUrl, 'customerSignupToken')
  url = removeQueryParam(url, 'customerSignupToken')

  const request: SendGridRequest = {
    email: data.email,
    list: data.list,
    language: data.language,
    market: data.country.code,
    geoCountry: data.getCountry,
    url: url,
    urlLastClick: lastUrl,
    source: 'gubi account profile page',
    signupDate: new Date().toISOString(),
    newsletterSignup: true,
  }

  const response = await fetch(
    'https://hook.eu1.make.com/aa14tqufpisi6ahbas6b76f4luxv8u7a',
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(request),
    },
  )

  pushNewsletterTrackingEvent({
    newsletter: data.list,
    email: data.email,
  })

  return response
}

export default signupNewsletter
